/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type ServiceStatus = (typeof ServiceStatus)[keyof typeof ServiceStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ServiceStatus = {
	operational: 'operational',
	degraded: 'degraded',
	outage: 'outage',
	maintenance: 'maintenance',
	unknown: 'unknown',
} as const;
